import React from 'react';
import type { CurrentSubscription } from './types';

interface UsageCardProps {
  currentSubscription: CurrentSubscription | null;
}

export const UsageCard: React.FC<UsageCardProps> = ({ currentSubscription }) => {
  if (!currentSubscription?.usage || !currentSubscription?.limits) {
    return null;
  }

  const { usage, limits } = currentSubscription;

  return (
    <div className="mt-12 bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Your Current Usage</h3>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-gray-600">Sites Created</p>
          <p className="text-2xl font-bold text-gray-900">
            {usage.sites || 0} / {limits.maxSites || 1}
          </p>
          <div className="mt-2 bg-gray-200 rounded-full h-2">
            <div
              className="bg-blue-600 h-2 rounded-full"
              style={{
                width: `${((usage.sites || 0) / (limits.maxSites || 1)) * 100}%`,
              }}
            />
          </div>
        </div>
        <div>
          <p className="text-sm text-gray-600">Total Pages</p>
          <p className="text-2xl font-bold text-gray-900">{usage.pages || 0}</p>
          <p className="text-xs text-gray-500 mt-1">Max {limits.maxPagesPerSite || 5} per site</p>
        </div>
      </div>
    </div>
  );
};
